
import Vue from 'vue';
import { newsletterCategories } from '~/src/modules/customer/types/newsletterCategories';
import { faCalendar, faPlus, faXmark } from '@delfi.lt/fa-kit/icons/modules/classic/regular';

interface NewsletterWindow extends Window {
  tp: any;
}

declare const window: NewsletterWindow;

export default Vue.extend({
  props: {
    customerToken: {
      type: String,
    },

    customerHasAccess: {
      type: Boolean,
    },

    activePage: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      categories: JSON.parse(JSON.stringify(newsletterCategories)),
      faCalendar,
      faPlus,
      faXmark,
      isUserConfirmed: false,
      plusContentNewsConsent: false,
    };
  },

  methods: {
    async fetchSubscribedItems() {
      try {
        /*
          await fetch('https://paywall.delfi.lt/newsletter/move-anonymouslits-to-reglist', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.customerToken}`,
            },
          });
        */
        const response = await fetch('https://paywall.delfi.lt/newsletter/get-reg-esp-list', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.customerToken}`,
          },
        });

        const data = await response.json();

        let subscribedNames: string[] = [];

        try {
          subscribedNames = JSON.parse(data.inList ?? '[]');
        } catch (e) {
          console.error('Failed to parse inList', e);
        }

        for (const category of this.categories) {
          for (const item of category.items) {
            if (item.name === 'Savaitės naujienos') {
              continue;
            }

            item.subscribed = subscribedNames.includes(item.name);
          }
        }
      } finally {
        for (const category of this.categories) {
          for (const item of category.items) {
            item.loading = false;
          }
        }
      }
    },

    async toggleSubscription(catIndex: number, index: number) {
      const item = this.categories[catIndex].items[index];

      if (!item || item.loading) {
        return;
      }

      item.loading = true;

      try {
        const newSubscribedState = !item.subscribed;
        const action = newSubscribedState ? 'subscribe' : 'unsubscribe';

        const success = await this.updateSubscription(item.espId, action);

        if (!success) {
          return;
        }

        if (item.name === 'Savaitės naujienos') {
          const customFieldUpdated = await this.updatePianoCustomFields([
            {
              field_name: 'plus-content-news-consent',
              value: newSubscribedState ? 'true' : 'false',
            },
          ]);

          if (!customFieldUpdated) {
            return;
          }

          this.plusContentNewsConsent = newSubscribedState;
        }

        item.subscribed = newSubscribedState;
      } finally {
        item.loading = false;
      }
    },

    async updatePianoCustomFields(customFields: any[]): Promise<boolean> {
      try {
        const token = window.tp.pianoId.getToken();
        const uid = window.tp.pianoId.getUser()?.uid;

        if (!token || !uid) throw new Error('Missing Piano token or UID');

        const response = await fetch(`https://api-eu.piano.io/id/api/v1/identity/userinfo?lang=en_US&aid=${window.tp.aid}&access_token=${token}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json; charset=UTF-8' },
          body: JSON.stringify({ uid, custom_field_values: customFields }),
        });

        if (!response.ok) {
          const errorDetails = await response.json();
          console.error('API error details:', errorDetails);
          throw new Error('Failed to update custom fields');
        }
        console.log('Custom fields updated:', await response.json());
        return true;
      } catch (error) {
        console.error('Error updating user custom fields:', error);
        return false;
      }
    },

    async updateSubscription(espId: number, action: 'subscribe' | 'unsubscribe'): Promise<boolean> {
      try {
        const response = await fetch('https://paywall.delfi.lt/newsletter/update-newsletter-list-v2', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.customerToken}`,
          },
          body: JSON.stringify({
            espId,
            action,
          }),
        });

        return response.ok;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    loadPianoData() {
      const initPiano = () => {
        if (!window.tp || typeof window.tp.push !== 'function') {
          setTimeout(initPiano, 100);
          return;
        }

        window.tp.push([
          'init',
          () => {
            this.isUserConfirmed = window.tp.user.isUserConfirmed();

            window.tp.pianoId.loadExtendedUser({
              extendedUserLoaded: (data: any) => {
                const consent = data.custom_field_values.find((f: any) => f.field_name === 'plus-content-news-consent');

                this.plusContentNewsConsent = consent?.value === 'true';

                const newsletter = this.categories.flatMap((category: any) => category.items).find((item: any) => item.name === 'Savaitės naujienos');

                if (newsletter) {
                  newsletter.subscribed = this.plusContentNewsConsent;
                }
              },
            });
          },
        ]);
      };

      initPiano();
    },
  },

  mounted() {
    if (this.customerToken) {
      this.fetchSubscribedItems().then(() => {
        this.loadPianoData();
      });
    } else {
      this.$watch(
        () => this.customerToken,
        (token) => {
          if (!token) {
            return;
          }

          this.fetchSubscribedItems().then(() => {
            this.loadPianoData();
          });
        }
      );
    }
  },
});
